<script>
export default {
  name: "MenuPage"
}
</script>

<template>
  <el-row class="tac">
    <el-col :span="24">
      <el-menu
          router
          default-active="0"
          class="el-menu-vertical-demo"
          :default-openeds="$router.path">
        <el-menu-item index="/admin/posts">
          <i class="el-icon-menu"></i>
          <span>文章列表</span>
        </el-menu-item>
        <el-menu-item index="/admin/category">
          <i class="el-icon-menu"></i>
          <span>分类列表</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>

<style scoped>

</style>